import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, map, withLatestFrom } from 'rxjs/operators';
import { AppStore } from 'src/app/store/store.model';
import {
  isFeatureFlagEnabled,
  getFeatureFlagsLoaded,
} from '../store/feature-flags/feature-flags.selectors';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard {
  constructor(private router: Router, private store: Store<AppStore>) {}

  canActivate(route: ActivatedRouteSnapshot) {
    return this.store.select(getFeatureFlagsLoaded).pipe(
      first((loaded) => loaded),
      withLatestFrom(this.store.select(isFeatureFlagEnabled(route.data.featureFlag))),
      map(([_, enabled]) => {
        if (!enabled) {
          this.router.navigate([route.data.featureFlagDisabledUrl ?? '/dashboard']);
          return false;
        }

        return true;
      }),
    );
  }
}
